import {reservePwaReload} from './pwaReload';
export function isChunkLoadError(error:any):boolean {
 const message=typeof error==='string'?error:String(error?.message||'');
 return error?.name==='ChunkLoadError'||/ChunkLoadError|Loading(?: CSS)? chunk[\s\S]*failed|Failed to fetch dynamically imported module|Importing a module script failed|(?:MIME|script|JavaScript)[\s\S]*text\/html|text\/html[\s\S]*(?:MIME|script|JavaScript)/i.test(message);
}
let recovery:Promise<boolean>|null=null;
async function bounded(work:Promise<any>,milliseconds=2000){
 let timer:ReturnType<typeof setTimeout>|undefined;
 try{await Promise.race([work.catch(()=>{}),new Promise(resolve=>{timer=setTimeout(resolve,milliseconds);})]);}
 finally{if(timer)clearTimeout(timer);}
}
export function recoverChunkLoadError(error:any,reload=()=>{
 const url=new URL(window.location.href);url.searchParams.set('__zoma_refresh',String(Date.now()));window.location.replace(url.href);
}):Promise<boolean> {
 if(!isChunkLoadError(error))return Promise.resolve(false);
 if(recovery)return recovery;
 if(!reservePwaReload())return Promise.resolve(false);
 recovery=(async()=>{
  const tasks:Promise<any>[]=[];
  if('serviceWorker' in navigator)tasks.push(navigator.serviceWorker.getRegistrations().then(registrations=>Promise.allSettled(registrations.filter(reg=>reg.scope===window.location.origin+'/').map(reg=>reg.unregister()))));
  if('caches' in window)tasks.push(caches.keys().then(names=>Promise.allSettled(names.filter(name=>name.startsWith('zoma-shell-')||name.startsWith('fieldcro-')).map(name=>caches.delete(name)))));
  await bounded(Promise.allSettled(tasks));
  // CacheStorage deletion cannot clear an immutable browser HTTP response.
  // Refresh only the exact same-origin public asset named by the failed loader.
  try {
   const failed=new URL(error?.request||'',window.location.href);
   if(failed.origin===window.location.origin&&/^\/static\/(?:js|css)\/[\w.-]+\.(?:js|css)$/.test(failed.pathname))await bounded(fetch(failed.href,{cache:'reload',credentials:'omit'}));
  }catch(_){}
  reload();return true;
 })().catch(()=>false);
 return recovery;
}
export function installChunkRecovery(){
 const handle=(event:PromiseRejectionEvent|ErrorEvent)=>{
  const error='reason' in event?event.reason:event.error||event.message;
  if(!isChunkLoadError(error))return;
  event.preventDefault();
  let notice=document.getElementById('zoma-pwa-update');
  if(!notice){notice=document.createElement('p');notice.id='zoma-pwa-update';notice.setAttribute('role','status');document.body.appendChild(notice);}
  notice.textContent='Nova verzija aplikacije, osvježavam';
  void recoverChunkLoadError(error).then(reloaded=>{if(!reloaded&&notice)notice.textContent='Nova verzija aplikacije nije dostupna. Osvježite kasnije.';});
 };
 window.addEventListener('unhandledrejection',handle);
 window.addEventListener('error',handle);
}
